import { useState } from 'react';

export const formTabEnums = {
    CREATOR: 'CREATOR',
    BUILDER: 'BUILDER',
    PREVIEW: 'PREVIEW',
};

export function transformNotesObject(arr) {
    return arr.map((key) => {
        const formattedKey = key
            .replace(/_/g, ' ')
            .toLowerCase()
            .replace(/(^\w|\s\w)/g, (match) => match.toUpperCase());

        return { id: key, name: formattedKey };
    });
}

export const formFunctions = () => {
    const [formList, setFormList] = useState({
        attributes: [],
    });

    return { formList, setFormList };
};
